import { createRoot } from "react-dom/client";
import App from "./App";
import posthog from "posthog-js";
import { PUBLIC_POSTHOG_HOST, PUBLIC_POSTHOG_KEY } from "./config";

const rootElement = document.getElementById("root");

if (rootElement) {
  posthog.init(PUBLIC_POSTHOG_KEY, {
    api_host: PUBLIC_POSTHOG_HOST,
    defaults: "2026-05-30",
  });
  createRoot(rootElement).render(<App />);
} else {
  throw new Error("Root element not found");
}
